<template>
  <div class="">
    <form autocomplete="off">
      <div class="row">
        <CustomFileInput
          :className="'col-12'"
          @changeValue="category.mediaFile = $event.file"
          :defaultImg="
            fullPathFileFromServer(
              category.categoryImagePath,
              category.defaultImg
            )
          "
          :deleteFileStatus="
            deleteFileStatus &&
            !category.categoryImageIsDefault &&
            checkPrivilege(hasCategoryDeleteImage())
          "
          v-on:deleteFile="$emit('deleteFile')"
        />
      </div>

      <div class="my-card">
        <div class="row">
          <CustomInput
            :className="'col-md-6'"
            :id="`${id}-fullCode`"
            :value="category.fullCode"
            v-on:changeValue="category.fullCode = $event"
            :title="$t('Categories.code')"
            :imgName="'code.svg'"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="`${id}-categoryNameAr`"
            :errors="errors_categoryNameAr"
            :value="category.categoryNameAr"
            v-on:changeValue="
              category.categoryNameAr = $event;
              $v.category.categoryNameAr.$touch();
            "
            :title="$t('Categories.nameAr')"
            :imgName="'categories.svg'"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="`${id}-categoryNameEn`"
            :errors="errors_categoryNameEn"
            :value="category.categoryNameEn"
            v-on:changeValue="
              category.categoryNameEn = $event;
              $v.category.categoryNameEn.$touch();
            "
            :title="$t('Categories.nameEn')"
            :imgName="'categories.svg'"
          />
          <CustomInput
            :className="'col-md-6'"
            :id="`${id}-categoryNameUnd`"
            :value="category.categoryNameUnd"
            v-on:changeValue="category.categoryNameUnd = $event"
            :title="$t('Categories.nameUnd')"
            :imgName="'categories.svg'"
          />

          <TextArea
            :className="'col-md-6'"
            :id="`${id}-categoryDescriptionAr`"
            :errors="errors_categoryDescriptionAr"
            :value="category.categoryDescriptionAr"
            v-on:changeValue="
              category.categoryDescriptionAr = $event;
              $v.category.categoryDescriptionAr.$touch();
            "
            :title="$t('Categories.descriptionAr')"
            :imgName="'description.svg'"
          />
          <TextArea
            :className="'col-md-6'"
            :id="`${id}-categoryDescriptionEn`"
            :errors="errors_categoryDescriptionEn"
            :value="category.categoryDescriptionEn"
            v-on:changeValue="
              category.categoryDescriptionEn = $event;
              $v.category.categoryDescriptionEn.$touch();
            "
            :title="$t('Categories.descriptionEn')"
            :imgName="'description.svg'"
          />
          <TextArea
            :className="'col-md-6'"
            :id="`${id}-categoryDescriptionUnd`"
            :value="category.categoryDescriptionUnd"
            v-on:changeValue="category.categoryDescriptionUnd = $event"
            :title="$t('Categories.descriptionUnd')"
            :imgName="'description.svg'"
          />
          <TextArea
            :className="'col-md-6'"
            :id="`${id}-categoryNotes`"
            :value="category.categoryNotes"
            v-on:changeValue="category.categoryNotes = $event"
            :title="$t('notes')"
            :imgName="'notes.svg'"
          />
        </div>
      </div>

      <div class="form-actions">
        <div class="icon-submit" @click.prevent="submitForm">
          <img src="@/assets/images/check-icon.svg" :title="submitName" />
        </div>
        <div
          @click.prevent
          class="icon-cancel"
          v-b-modal="`ConfirmCloseSheet-${bottomSheetName}`"
        >
          <img src="@/assets/images/cancel-icon.svg" :title="$t('cancel')" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  fullPathFileFromServer,
  bottomSheetScrollToTop,
} from "./../../../../../utils/functions";
import {
  isValidNameAr,
  isValidNameEn,
  isValidTextAr,
  isValidTextEn,
} from "./../../../../../utils/validationHelper";
import CustomFileInput from "./../../../../../components/general/CustomFileInput.vue";
import CustomInput from "./../../../../../components/general/CustomInput.vue";
import TextArea from "./../../../../../components/general/TextArea.vue";
import { hasCategoryDeleteImage } from "./../../../../../utils/privilegeHelper";
import { checkPrivilege } from "./../../../../../utils/functions";
import generalMixin from "./../../../../../utils/generalMixin";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [generalMixin, validationMixin],
  components: {
    CustomFileInput,
    CustomInput,
    TextArea,
  },
  // data() {
  //   return {};
  // },
  props: {
    category: {
      type: Object,
    },
    submitName: {
      type: String,
    },
    id: {
      type: String,
      default: "id",
    },
    deleteFileStatus: {
      type: Boolean,
      default: false,
    },
    bottomSheetName: {
      type: String,
      default: "",
    },
  },
  validations: {
    category: {
      categoryNameAr: { required, isValidNameAr },
      categoryNameEn: { required, isValidNameEn },
      categoryDescriptionAr: { isValidTextAr },
      categoryDescriptionEn: { isValidTextEn },
    },
  },
  computed: {
    errors_categoryNameAr() {
      let errors = [];
      if (this.$v.category.categoryNameAr.$error) {
        if (
          !this.$v.category.categoryNameAr.required &&
          !this.$v.category.categoryNameEn.required
        )
          errors.push(this.$t("validation.fieldIsRequired"));
        else if (
          this.$v.category.categoryNameAr.required &&
          !this.$v.category.categoryNameAr.isValidNameAr
        )
          errors.push(this.$t("validation.nameIsRequiredInAr"));
      }
      return errors;
    },
    errors_categoryNameEn() {
      let errors = [];
      if (this.$v.category.categoryNameEn.$error) {
        if (
          !this.$v.category.categoryNameAr.required &&
          !this.$v.category.categoryNameEn.required
        )
          errors.push(this.$t("validation.fieldIsRequired"));
        else if (
          this.$v.category.categoryNameEn.required &&
          !this.$v.category.categoryNameEn.isValidNameEn
        )
          errors.push(this.$t("validation.nameIsRequiredInEn"));
      }
      return errors;
    },
    errors_categoryDescriptionAr() {
      let errors = [];
      if (this.$v.category.categoryDescriptionAr.$error) {
        if (!this.$v.category.categoryDescriptionAr.isValidTextAr)
          errors.push(this.$t("validation.fieldIsRequiredInAr"));
      }
      return errors;
    },
    errors_categoryDescriptionEn() {
      let errors = [];
      if (this.$v.category.categoryDescriptionEn.$error) {
        if (!this.$v.category.categoryDescriptionEn.isValidTextEn)
          errors.push(this.$t("validation.fieldIsRequiredInEn"));
      }
      return errors;
    },
  },
  methods: {
    async submitForm() {
      bottomSheetScrollToTop();
      this.$v.$touch();
      if (
        ((this.$v.category.categoryNameAr.required &&
          this.$v.category.categoryNameAr.isValidNameAr) ||
          (this.$v.category.categoryNameEn.required &&
            this.$v.category.categoryNameEn.isValidNameEn)) &&
        this.$v.category.categoryDescriptionAr.isValidTextAr &&
        this.$v.category.categoryDescriptionEn.isValidTextEn
      ) {
        this.$emit("submitForm");
      }
    },
    checkPrivilege,
    hasCategoryDeleteImage,
    fullPathFileFromServer,
  },
};
</script>
